import { createSlice } from "@reduxjs/toolkit";

const initialState = { selected_data: [] };

const mapScreenDataSlice = createSlice({
    name: "mapScreenData",
    initialState,
    reducers: {
        getMapScreenData: (state, action) => {
            const { rowSelection, tableValues } = action.payload;
            const screen_uiid = Object.keys(rowSelection).map(String);
            const selectedData = tableValues.filter((data) => screen_uiid.includes(data.screen_uiid));

            return { ...state, selected_data: selectedData };
        },
    },
});

export const { getMapScreenData } = mapScreenDataSlice.actions;

export default mapScreenDataSlice.reducer;
